import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { useGetMealschoiceQuery, useGetAllFoodItemListQuery, usePostUserMealMutation } from '../../../../store/api/meals';
function Mealdetail() {
    const navigate = useNavigate();
    const { data: choiceData, isLoading } = useGetMealschoiceQuery();
    const [postUserMeal] = usePostUserMealMutation()
    const { data: mealsData } = useGetAllFoodItemListQuery();
    const [selectedMeals, setSelectedMeals] = useState({});
    const [mealUnits, setMealUnits] = useState({});
    const [mealQuantities, setMealQuantities] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation();
    const [feedback, setFeedback] = useState({});
    const userData = location.state?.userData;
    const userQA = userData['question-answer'];
    
    console.log(mealsData,"data");
    
    const mealoptions = mealsData ? mealsData.data.map(item => ({ id: item.id, name: item.name })) : [];
    const formattedArray = choiceData ? choiceData.map(item => item.key) : [];

    
    const handleSelect = (selectedList, mealKey) => {
        setSelectedMeals(prev => ({
            ...prev,
            [mealKey]: selectedList
        }));
    };
    const handleSubmit = (event) => {
        event.preventDefault();

        const formattedData = {
            meals: Object.entries(selectedMeals).map(([mealKey, meals]) => ({
                name: mealKey,
                food_items: meals.map((meal) => ({
                    id: meal.id,
                    unit: mealUnits[mealKey]?.[meal.name] || "gram",
                    quantity: mealQuantities[mealKey]?.[meal.name] || 1
                }))
            }))
        };
        Object.keys(selectedMeals).length === 0 ? setFeedback({ message: "Add atleast one meal item", type: '1' }) : setIsModalOpen(true);
        setTimeout(() => {
            setFeedback({});
        }, 1000);
    };
    const handleUnitChange = (mealKey, mealName, event) => {
        setMealUnits(prevUnits => ({
            ...prevUnits,
            [mealKey]: {
                ...prevUnits[mealKey],
                [mealName]: event.target.value
            }
        }));
    };
    const handleQuantityChange = (mealKey, mealName, event) => {
        setMealQuantities(prevQuantities => ({
            ...prevQuantities,
            [mealKey]: {
                ...prevQuantities[mealKey],
                [mealName]: event.target.value
            }
        }));
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedMeals({});
        setMealUnits({});
        setMealQuantities({});
    };
    const dataTosubmit = async () => {
        try {
            const dataToSubmit = Object.entries(selectedMeals).map(([mealKey, meals]) => ({
                name: mealKey,
                food_items: meals.map(meal => ({
                    id: meal.id,
                    name: meal.name,
                    unit: mealUnits[mealKey]?.[meal.name] || "gram",
                    quantity: mealQuantities[mealKey]?.[meal.name] || 1
                }))
            }));
                console.log(dataToSubmit,"datatosubmit");
                
            setTimeout(() => {
                setFeedback({});
                closeModal()
            }, 2000);
            console.log(dataToSubmit,"datatatt");
            const response = await postUserMeal({ member: userData.user_id, meals: dataToSubmit });
            setFeedback({ message: "Meals Assigned Successfully", type: 'success' })

            if (response.data) {
                setTimeout(() => {
                 navigate('/asigned-meal-list')   
                }, 2000);
            }

            if (response.error.status === 400) {
                setFeedback({ message: "This user has already been assigned a meal", type: 'error' })
            }


        } catch (error) {

            console.log(error, "error");

        }
    }
    return (
        <div className="w-full rounded-xl mt-2 px-5 mx-auto py-3">
            <div className="py-4 bg-white rounded-lg shadow px-3">
                <div className="flex justify-between items-center border-b pb-4 mb-4 ml-3">
                    <h1 className=" font-bold text-md">{userData?.user_name} <span className="text-gray-600">({userData?.email})</span></h1>
                </div>
                <div className="flex mb-4">
                    <div className="w-[40%] rounded-sm mx-2 shadow-xl">
                        <div className="w-[100%] bg-white-50 border border-collapse rounded-lg mt-3">
                            <div className="ml-4">
                                <h2 className="mt-3 text-lg font-medium mb-4 mx-2">Create Meal</h2>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className='flex flex-col text-xs px-6 mb-3 mt-4 font-bold'>
                                    {formattedArray.map((mealKey) => (
                                        <div className='mt-5' key={mealKey}>
                                            <label className='mt-5 '> {mealKey}</label>
                                            <Multiselect
                                                className="mt-2 text-sm w-full "
                                                options={mealoptions}
                                                selectedValues={selectedMeals[mealKey]}
                                                onSelect={(selectedList) => handleSelect(selectedList, mealKey)}
                                                onRemove={(selectedList) => handleSelect(selectedList, mealKey)}
                                                displayValue="name"
                                            />
                                        </div>
                                    ))}
                                    {feedback?.type === '1' && (
                                        <div
                                            className="mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium bg-red-100 text-red-700 border border-red-300"
                                            role="alert"
                                        >
                                            {feedback.message}
                                        </div>
                                    )}

                                    <div className='mt-3 mb-3'>
                                        <button
                                            type="submit"
                                            className='px-4 py-2 bg-secondary text-white font-semibold rounded-lg  '>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="w-[60%] bg-white-500 h-14 mt-3 shadow rounded-lg">
                        <div className="mt-2 ml-4">
                            <h2 className="text-lg font-medium mb-4 mt-2">Answers</h2>
                        </div>
                        <div className="w-[100%] bg-white-50 rounded-sm shadow-sm mt-6">
                            <div>
                                <table className="w-full border border-collapse border-gray-300 mt-4">
                                    <thead>
                                        <tr className="bg-white-200">
                                            <th className="border w-1/4 border-gray-300 p-2">S.No</th>
                                            <th className="border border-gray-300 p-2">Question-Answers</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(userQA).map(([key, value], index) => (
                                            <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                                                <td className="border border-gray-300 p-2 text-center text-sm text-gray-700  text-bold font-normal">{index + 1}</td>
                                                <td className="border px-5 border-gray-300 p-2 text-sm text-gray-700 font-normal">{`${key} ?  `} <br /><span>{`${value}`}</span></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 x-y rounded-lg shadow-lg w-[80%] max-w-3xl">
                        <div className=' min-h-[100px] max-h-[400px] overflow-y-scroll '>
                            <h2 className="text-xl font-semibold mb-4">Selected Meals</h2>
                            {feedback?.type === "success" && (
                                <div
                                    className="mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium bg-green-100 text-green-700 border border-green-300"
                                    role="alert"
                                >
                                    {feedback.message}
                                </div>
                            )}
                            {feedback?.type === "error" && (
                                <div
                                    className="mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium bg-red-100 text-red-700 border border-red-300"
                                    role="alert"
                                >
                                    {feedback.message}
                                </div>
                            )}

                            <table className="w-full border  border-gray-300 mt-4">
                                <thead>
                                    <tr className="bg-white-200">
                                        <th className="border w-1/4 border-gray-300 p-2">Meal</th>
                                        <th className="border border-gray-300 p-2">Food Item</th>
                                        <th className="border border-gray-300 p-2">Unit</th>
                                        <th className="border border-gray-300 p-2">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(selectedMeals).map(([mealKey, meals], index) => (
                                        meals.map((meal, idx) => (
                                            <tr key={`${index}-${idx}`} className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                                                {idx === 0 && ( 
                                                    <td className="border px-5 border-gray-300 p-2" rowSpan={meals.length}>
                                                        {mealKey}
                                                    </td>
                                                )}
                                                <td className="border px-5 border-gray-300 p-2">{meal.name}</td>
                                                <td className="border px-5 border-gray-300 p-2">
                                                    <select
                                                        value={mealUnits[mealKey]?.[meal.name] || ''}
                                                        onChange={(e) => handleUnitChange(mealKey, meal.name, e)}
                                                        className="p-2 border rounded"
                                                    >
                                                        <option value="">Select Unit</option>
                                                        <option value="grams">Grams</option>
                                                        <option value="protein">Protein</option>
                                                        <option value="ounce">Ounce</option>
                                                        <option value="ltr">Litre</option>
                                                    </select>
                                                </td>
                                                <td className="border px-5 border-gray-300 p-2">
                                                    <input
                                                        type="number"
                                                        value={mealQuantities[mealKey]?.[meal.name] || ''}
                                                        onChange={(e) => handleQuantityChange(mealKey, meal.name, e)}
                                                        className="p-2 border rounded w-20"
                                                        placeholder="Quantity"
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ))}
                                </tbody>

                            </table>
                        </div>

                        <div className="mt-4 text-right">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2  bg-gray-300 text-black font-semibold rounded-lg mr-3">
                                Close
                            </button>
                            <button
                                onClick={dataTosubmit}
                                className="px-4 py-2  bg-secondary text-white font-semibold rounded-lg">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default Mealdetail;
